import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const NotificationBell = (props) => (
    <SvgIcon {...props} sx={{ cursor: "pointer" }}>
        <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7839 16.8C11.7839 18.2912 10.5751 19.5 9.08389 19.5C7.59272 19.5 6.38389 18.2912 6.38389 16.8M2.78389 12.3V7.8C2.78389 4.32061 5.60449 1.5 9.08389 1.5C12.5633 1.5 15.3839 4.32061 15.3839 7.8V12.3C16.378 12.3 17.1839 13.1059 17.1839 14.1C17.1839 15.0941 16.378 15.9 15.3839 15.9H2.78389C1.78977 15.9 0.983887 15.0941 0.983887 14.1C0.983887 13.1059 1.78977 12.3 2.78389 12.3Z" stroke="#8387BD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </SvgIcon>
);

export default NotificationBell;